// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "8cc0a37c" + ".chunk.js";
};